import { render, staticRenderFns } from "./tylist.vue?vue&type=template&id=d21a166c&scoped=true&"
import script from "./tylist.vue?vue&type=script&lang=js&"
export * from "./tylist.vue?vue&type=script&lang=js&"
import style0 from "./tylist.vue?vue&type=style&index=0&id=d21a166c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21a166c",
  null
  
)

export default component.exports